import { render, staticRenderFns } from "./VersionShow.vue?vue&type=template&id=0634682c&scoped=true&"
import script from "./VersionShow.vue?vue&type=script&lang=js&"
export * from "./VersionShow.vue?vue&type=script&lang=js&"
import style0 from "./VersionShow.vue?vue&type=style&index=0&id=0634682c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634682c",
  null
  
)

export default component.exports